interface Props {
  options: string[];
  onSelect: (option: string) => void;
  disabled?: boolean;
}

export default function ClarificationChips({ options, onSelect, disabled }: Props) {
  if (!options || options.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-2 mt-2">
      {options.map((opt) => (
        <button
          key={opt}
          type="button"
          disabled={disabled}
          onClick={() => onSelect(opt)}
          className="px-3 py-1.5 rounded-full text-sm font-medium border border-primary-200 text-primary-700 bg-primary-50 hover:bg-primary-100 hover:border-primary-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {opt}
        </button>
      ))}
    </div>
  );
}
